// Helpers de roles/perfiles de usuario.
// El perfil de cajero se guarda como "POS" (Cajero/a en Users.vue / UserForm.vue);
// "USUARIO" es el valor legado / por defecto y también cae en el menú de cajero.
export const CASHIER_ROLES = ["POS", "USUARIO"];

// Rutas (name del router) que el cajero no debe ver ni abrir.
export const CASHIER_BLOCKED_ROUTES = ["Cash_report", "CashReports"];

export function isCashier(profile) {
  const access = profile && profile.user_access ? profile.user_access : "USUARIO";
  return CASHIER_ROLES.includes(access);
}

export function isRouteBlockedForCashier(routeName) {
  return CASHIER_BLOCKED_ROUTES.includes(routeName);
}
